/* eslint-disable jsx-a11y/anchor-is-valid */
/* eslint-disable no-unused-expressions */
/* eslint-disable react/jsx-props-no-spreading */
import React from 'react';
import { Typography, Box, Grid, Button } from '@mui/material';
import ExpandLessIcon from '@mui/icons-material/ExpandLess';
import { styled } from '@mui/material/styles';
import TextField from '@mui/material/TextField';
import Autocomplete from '@mui/material/Autocomplete';
import { useTranslation } from 'react-i18next';
import Icon from '@mdi/react';
import { mdiTableOfContents, mdiEmail } from '@mdi/js';

// Components

import { theme as daaasUITheme, Link } from 'daaas-ui';
import { HelpDrawer, SupportDialog } from '../components/UI/Dialogs';
import TOCDrawer from '../components/Layout/TOCDrawer';
import ContentContainer from '../components/Layout/ContentContainer';
import ContentSection from '../components/Layout/ContentSection';
import Banner from '../components/UI/Banner';
import BrandingDAS from '../components/Layout/BrandingDAS';

const Root = styled('div')(({ theme }) => ({
  'div:is(.sticky__nav, .Drawer-drawerContent) ul li .MuiTypography-root ': {
    fontSize: '1rem',
  },
  '.banner__header': {
    fontSize: `3.5rem !important`,
    lineHeight: '1.275',
    letterSpacing: '0.47',
    [theme.breakpoints.up('sm')]: {
      fontSize: `5rem !important`,
    },
  },
  '.sticky__nav': {
    position: 'sticky',
    top: 0,
    paddingTop: theme.spacing(2),
    paddingBottom: theme.spacing(2),
    paddingLeft: theme.spacing(4),
    paddingRight: theme.spacing(4),
  },

  '.bullet__alignment': {
    paddingLeft: theme.spacing(0),
    [theme.breakpoints.down('md')]: {
      paddingLeft: theme.spacing(2),
    },
    '& li': {
      paddingBottom: theme.spacing(0.5),
      paddingTop: theme.spacing(0.5),
    },
  },
}));

export default function FAQ() {
  const [questionsValue, setQuestionsValue] = React.useState(null);
  const [questionsInputValue, setQuestionsInputValue] = React.useState('');
  const [open, setOpen] = React.useState({
    onThisPageDrawer: false,
    helpDrawer: false,
  });
  const openDrawer = (element) => {
    setOpen({ ...open, [element]: true });
  };
  const toggleDialog = (element, value) => {
    setOpen({ ...open, [element]: value });
  };
  const closeDrawer = (element) => {
    setOpen({ ...open, [element]: false });
  };
  const [windowWidth, setWindowWidth] = React.useState(window.innerWidth);
  const isSmScreen = windowWidth < daaasUITheme.breakpoints.values.md;
  const { t, i18n } = useTranslation(['faq', 'common', 'dialogs']);
  React.useEffect(() => {
    // Detect screen size
    const handleResize = () => setWindowWidth(window.innerWidth);
    window.addEventListener('resize', handleResize);
    window.addEventListener('ScreenOrientation', handleResize);
    return () => {
      window.removeEventListener('resize', handleResize);
      window.removeEventListener('ScreenOrientation', handleResize);
    };
  }, []);

  const questions = [
    { label: t('box1FirstHeading'), anchor: 'faq1' },
    { label: t('box1SecondHeading'), anchor: 'faq2' },
    { label: t('box1ThirdHeading'), anchor: 'faq3' },
    { label: t('box2FirstHeading'), anchor: 'faq4' },
    { label: t('box2SecondHeading'), anchor: 'faq5' },
    {
      label: t('box3SecondHeading'),
      anchor: 'faq6',
    },
    {
      label: t('box3ThirdHeading'),
      anchor: 'faq7',
    },
    {
      label: t('box3SecondtHeading'),
      anchor: 'faq8',
    },

    {
      label: t('box4SecondHeading'),
      anchor: 'faq9',
    },
    {
      label: `${t('box4FirstHeading')} - ${t('billing')}`,
      anchor: 'faq10',
    },
    {
      label: `${t('box5FirstHeading')} - ${t('howWillIPay')}`,
      anchor: 'faq11',
    },
    {
      label: `${t('box6FirstHeading')} - ${t('billing')}`,
      anchor: 'faq12',
    },
  ];

  // Function to reset the Autocomplete if a Link is clicked
  const resetAutocomplete = () => {
    setQuestionsValue(null);
    setQuestionsInputValue('');
  };

  React.useEffect(() => {
    setTimeout(() => {
      document.title = `${t('common:daaas')} - ${t('faq:bannerHeading')}`;
      document
        .querySelector("meta[name='description']")
        .setAttribute('content', t('faq:description'));
      document
        .querySelector("meta[name='keywords']")
        .setAttribute('content', t('faq:keywords'));
      document
        .querySelector("link[rel='canonical']")
        .setAttribute('href', t('faq:canonical'));
      document
        .querySelector("meta[name='dcterms.title']")
        .setAttribute('content', t('faq:dctermsTitle'));
      document
        .querySelector("meta[name='dcterms.description']")
        .setAttribute('content', t('faq:dctermsDescription'));
      document
        .querySelector("meta[name='dcterms.creator']")
        .setAttribute('content', t('common:dctermsCreator'));
      document
        .querySelector("meta[name='dcterms.language']")
        .setAttribute('content', t('common:dctermsLanguage'));
      document
        .querySelector("meta[name='dcterms.subject']")
        .setAttribute('content', t('common:dctermsSubject'));
    }, '100');

    resetAutocomplete();
  }, [i18n.language]);

  return (
    <Root>
      <Banner>
        <Typography
          className="banner__header"
          variant="h1"
          color="textPrimary"
          sx={{ py: 2, maxWidth: '35%' }}
        >
          {t('faq:bannerHeading')}
        </Typography>
      </Banner>
      <ContentContainer paddingBottom={false}>
        <ContentSection>
          <Typography variant="h2" id="top">
            {t('bannerPara1')}
          </Typography>
        </ContentSection>
        <ContentSection>
          <Grid
            container
            spacing={4}
            alignItems="stretch"
            sx={{ position: 'relative' }}
          >
            {!isSmScreen ? (
              <Grid
                item
                xs={12}
                md={6}
                lg={3}
                sx={(theme) => ({
                  marginTop: theme.spacing(0.5),
                })}
              >
                <Box className="das-paper sticky__nav">
                  <Typography variant="h4" sx={{ mb: 2 }} component="h2">
                    {t('onThisPage')}
                  </Typography>
                  <ul className="bullet__alignment">
                    <li>
                      <Typography variant="body1">
                        <Link href="#onThisPage1" onClick={resetAutocomplete}>
                          {t('heading1')}
                        </Link>
                      </Typography>
                    </li>
                    <li>
                      <Typography variant="body1">
                        <Link href="#onThisPage2" onClick={resetAutocomplete}>
                          {t('box1FourthHeading')}
                        </Link>
                      </Typography>
                    </li>
                    <li>
                      <Typography variant="body1">
                        <Link href="#onThisPage3" onClick={resetAutocomplete}>
                          {t('box3FirstHeading')}
                        </Link>
                      </Typography>
                    </li>
                    <li>
                      <Typography variant="body1">
                        <Link href="#onThisPage4" onClick={resetAutocomplete}>
                          {t('box4FirstHeading')}
                        </Link>
                      </Typography>
                    </li>
                    <li>
                      <Typography variant="body1">
                        <Link href="#onThisPage5" onClick={resetAutocomplete}>
                          {t('box5FirstHeading')}
                        </Link>
                      </Typography>
                    </li>
                    <li>
                      <Typography variant="body1">
                        <Link href="#onThisPage6" onClick={resetAutocomplete}>
                          {t('box6FirstHeading')}
                        </Link>
                      </Typography>
                    </li>
                  </ul>
                  <Autocomplete
                    sx={(theme) => ({
                      mt: theme.spacing(3),
                      '& .MuiAutocomplete-endAdornment': {
                        top: '50% !important',
                      },
                    })}
                    id="questions"
                    clearText=""
                    closeText=""
                    openText=""
                    noOptionsText={t('faq:noOptions')}
                    isOptionEqualToValue={(option, value) =>
                      option.anchor === value.anchor
                    }
                    options={questions}
                    value={questionsValue}
                    onChange={(event, value) => {
                      setQuestionsValue(value);
                      if (value !== null) {
                        window.location.hash = value.anchor;
                      }
                    }}
                    inputValue={questionsInputValue}
                    onInputChange={(event, newInputValue) => {
                      setQuestionsInputValue(newInputValue);
                    }}
                    renderInput={(params) => (
                      <TextField {...params} label={t('faq:questions')} />
                    )}
                    slotProps={{
                      paper: {
                        sx: {
                          '& .MuiAutocomplete-listbox': {
                            '& .MuiAutocomplete-option': {
                              fontSize: (theme) =>
                                theme.typography.body2.fontSize,
                            },
                          },
                        },
                      },
                    }}
                  />
                </Box>
              </Grid>
            ) : (
              <Button
                variant="contained"
                color="primary"
                sx={[
                  (theme) => ({
                    position: 'sticky',
                    top: theme.spacing(0),
                    width: '100%',
                    marginLeft: theme.spacing(4),
                  }),
                ]}
                onClick={() => openDrawer('onThisPageDrawer')}
                endIcon={<Icon path={mdiTableOfContents} size={1} />}
              >
                {t('onThisPage')}
              </Button>
            )}
            <Grid item xs={12} md={6} lg={9}>
              <Typography
                id="onThisPage1"
                variant="h2"
                color="textPrimary"
                sx={{ mb: 2 }}
              >
                {t('heading1')}
              </Typography>
              <Box
                className="das-paper"
                sx={{
                  p: 2,
                }}
              >
                <Typography
                  variant="h3"
                  component="h3"
                  sx={{ mb: 1 }}
                  id="faq1"
                >
                  {t('box1FirstHeading')}
                </Typography>
                <Typography sx={{ mb: 4 }}>{t('box1FirstPara')}</Typography>
                <Typography sx={{ mb: 4 }}>{t('box1SecondPara')}</Typography>
                <Typography sx={{ mb: 4 }}>{t('box1ThirdPara')}</Typography>
                <Typography
                  variant="h3"
                  component="h3"
                  sx={{ mb: 1 }}
                  id="faq2"
                >
                  {t('box1SecondHeading')}
                </Typography>
                <Typography sx={{ mb: 4 }}>{t('box1FourthPara')}</Typography>
                <Typography sx={{ mb: 4 }}>{t('box1FifthPara')}</Typography>
                <Typography
                  variant="h3"
                  component="h3"
                  sx={{ mb: 1 }}
                  id="faq3"
                >
                  {t('box1ThirdHeading')}
                </Typography>
                <Typography sx={{ mb: 4 }}>
                  {t('box1SixthPara')} (
                  <Link
                    href={t('common:hrefMsFormsGetStarted')}
                    target="_blank"
                  >
                    {t('linkToGetStartedForm')}
                  </Link>
                  ).
                </Typography>
                <Typography sx={{ mb: 4 }}>{t('box1SeventhPara')}</Typography>
                <Typography sx={{ mb: 4 }}>
                  {t('box1EighthPara')} (
                  <Link
                    href={`${t('common:/urlPrefix')}${t('common:/pricing')}`}
                  >
                    {t('linkToPricingPage')}
                  </Link>
                  ).
                </Typography>
                <Box sx={{ display: 'flex', justifyContent: 'center' }}>
                  <Button href="#top" endIcon={<ExpandLessIcon />}>
                    {t('backToTop')}
                  </Button>
                </Box>
              </Box>
              <ContentSection>
                <Typography
                  id="onThisPage2"
                  variant="h2"
                  component="h2"
                  sx={{ mb: 2 }}
                >
                  {t('box1FourthHeading')}
                </Typography>
                <Box
                  className="das-paper"
                  sx={{
                    p: 2,
                  }}
                >
                  <Typography
                    variant="h3"
                    component="h3"
                    sx={{ mb: 1 }}
                    id="faq4"
                  >
                    {t('box2FirstHeading')}
                  </Typography>
                  <Typography sx={{ mb: 4 }}>{t('box2FirstPara')}</Typography>
                  <Typography sx={{ mb: 4 }}>
                    {t('box2SecondPara')} (
                    <Link href={`${t('faq:linkToCSEHref')}`} target="_blank">
                      {t('linkToCSE')}
                    </Link>
                    ). {t('box2SecondText')} (
                    <Link href={`${t('faq:box2SecondUrl')}`} target="_blank">
                      {t('box2SecondLinks')}
                    </Link>
                    ).
                  </Typography>
                  <Typography sx={{ mb: 4 }}>{t('box2ThirdPara')}</Typography>
                  <Typography
                    variant="h3"
                    component="h3"
                    sx={{ mb: 1 }}
                    id="faq5"
                  >
                    {t('box2SecondHeading')}
                  </Typography>
                  <Typography sx={{ mb: 4 }}>
                    {t('box2FourthPara')} (
                    <Link
                      href={`${t('common:/urlPrefix')}${t('common:/pricing')}`}
                    >
                      {t('linkToPricingPage')}
                    </Link>
                    ).
                  </Typography>
                  <Typography sx={{ mb: 4 }}>{t('box2FifthPara')}</Typography>
                  <Box
                    sx={{ display: 'flex', justifyContent: 'center', pb: 2 }}
                  >
                    <Button href="#top" endIcon={<ExpandLessIcon />}>
                      {t('backToTop')}
                    </Button>
                  </Box>
                </Box>{' '}
              </ContentSection>{' '}
              <ContentSection>
                <Typography variant="h2" sx={{ mb: 2 }} id="onThisPage3">
                  {t('box3FirstHeading')}
                </Typography>
                <Box
                  className="das-paper"
                  sx={{
                    p: 2,
                  }}
                >
                  <Typography variant="h3" sx={{ mb: 1 }} id="faq6">
                    {t('box3SecondHeading')}
                  </Typography>
                  <Typography sx={{ mb: 4 }}>{t('box3FirstPara')}</Typography>
                  <Typography sx={{ mb: 4 }}>{t('box3SecondPara')}</Typography>
                  <Typography sx={{ mb: 1 }}>{t('box3ThirdPara')}</Typography>
                  <Typography variant="h3" sx={{ mt: 4, mb: 1 }} id="faq7">
                    {t('box3ThirdHeading')}
                  </Typography>
                  <Typography sx={{ mb: 4 }}>{t('box3FourthPara')}</Typography>
                  <Typography sx={{ mb: 4 }}>
                    {t('box3FifthPara')} {t('resourcesLink')} (
                    <Link href={`${t('common:/urlPrefix')}${t('common:/cae')}`}>
                      {t('linkToCAE')}
                    </Link>
                    ).
                  </Typography>
                  <Typography sx={{ mb: 4 }}>
                    {t('box3SixthPara')} {t('resourcesLink')} (
                    <Link href={`${t('common:/urlPrefix')}${t('common:/aaw')}`}>
                      {t('linkToAAW')}
                    </Link>
                    ).
                  </Typography>
                  <Typography sx={{ mb: 4 }}>
                    {t('box3SeventhPara')} {t('resourcesLink')} (
                    <Link href={`${t('common:/urlPrefix')}${t('common:/gae')}`}>
                      {t('linkToGAE')}
                    </Link>
                    ).
                  </Typography>
                  <Typography variant="h3" sx={{ mt: 4, mb: 1 }} id="faq8">
                    {t('box3SecondtHeading')}
                  </Typography>
                  <Typography sx={{ mb: 4 }}>{t('box3EighthPara')}</Typography>
                  <Typography sx={{ mb: 4 }}>{t('box3NinthPara')}</Typography>
                  <Typography sx={{ mb: 4 }}>{t('box3TenthPara')}</Typography>
                  <Typography sx={{ mb: 4 }}>
                    {t('box3EleventhPara')}
                  </Typography>
                  <Box
                    sx={{ display: 'flex', justifyContent: 'center', pb: 2 }}
                  >
                    <Button href="#top" endIcon={<ExpandLessIcon />}>
                      {t('backToTop')}
                    </Button>
                  </Box>
                </Box>
              </ContentSection>
              <ContentSection>
                <Typography variant="h2" sx={{ mb: 2 }} id="onThisPage4">
                  {t('box4FirstHeading')}
                </Typography>
                <Box
                  className="das-paper"
                  sx={{
                    p: 2,
                  }}
                >
                  <Typography variant="h3" sx={{ mb: 1 }} id="faq9">
                    {t('box4SecondHeading')}
                  </Typography>
                  <Typography sx={{ mb: 4 }}>{t('box4FirstPara')}</Typography>
                  <Typography variant="h3" sx={{ mt: 4, mb: 1 }} id="faq10">
                    {t('billing')}
                  </Typography>
                  <Typography sx={{ mb: 4 }}>{t('box4SecondPara')}</Typography>
                  <Box
                    sx={{ display: 'flex', justifyContent: 'center', pb: 2 }}
                  >
                    <Button href="#top" endIcon={<ExpandLessIcon />}>
                      {t('backToTop')}
                    </Button>
                  </Box>
                </Box>
              </ContentSection>
              <ContentSection>
                <Typography variant="h2" sx={{ mb: 2 }} id="onThisPage5">
                  {t('box5FirstHeading')}
                </Typography>
                <Box
                  className="das-paper"
                  sx={{
                    p: 2,
                  }}
                >
                  <Typography variant="h3" sx={{ mb: 1 }} id="faq11">
                    {t('howWillIPay')}
                  </Typography>
                  <Typography sx={{ mb: 4 }}>{t('box5SecondPara')}</Typography>
                  <Box
                    sx={{ display: 'flex', justifyContent: 'center', pb: 2 }}
                  >
                    <Button href="#top" endIcon={<ExpandLessIcon />}>
                      {t('backToTop')}
                    </Button>
                  </Box>
                </Box>
              </ContentSection>
              <ContentSection>
                <Typography variant="h2" sx={{ mb: 2 }} id="onThisPage6">
                  {t('box6FirstHeading')}
                </Typography>
                <Box
                  className="das-paper"
                  sx={{
                    p: 2,
                  }}
                >
                  <Typography variant="h3" sx={{ mb: 1 }} id="faq12">
                    {t('billing')}
                  </Typography>
                  <Typography sx={{ mb: 4 }}>{t('box6FirstPara')}</Typography>
                  <Box
                    sx={{ display: 'flex', justifyContent: 'center', pb: 2 }}
                  >
                    <Button href="#top" endIcon={<ExpandLessIcon />}>
                      {t('backToTop')}
                    </Button>
                  </Box>
                </Box>
              </ContentSection>
              <ContentSection>
                <Typography variant="h2" sx={{ mb: 2 }}>
                  {t('stillHaveQuestions')}
                </Typography>
                <Typography>
                  <Button
                    variant="text"
                    color="primary"
                    startIcon={<Icon path={mdiEmail} size={1} />}
                    onClick={() =>
                      toggleDialog('supportDialog', !open.supportDialog)
                    }
                  >
                    {t('dialogs:helpSupportButton')}
                  </Button>
                </Typography>
                <Typography sx={{ pb: 2 }}>
                  <Button href="#top" endIcon={<ExpandLessIcon />}>
                    {t('backToTop')}
                  </Button>
                </Typography>
              </ContentSection>
            </Grid>
          </Grid>
        </ContentSection>
      </ContentContainer>

      <BrandingDAS />
      <TOCDrawer
        open={open.onThisPageDrawer}
        toggleDialog={toggleDialog}
        openDrawer={openDrawer}
        closeDrawer={closeDrawer}
      />
      <HelpDrawer
        open={open.helpDrawer}
        closeDrawer={() => closeDrawer('helpDrawer')}
        toggleSupportDialog={() =>
          toggleDialog('supportDialog', !open.supportDialog)
        }
      />
      <SupportDialog
        open={open.supportDialog}
        toggleDialog={() => toggleDialog('supportDialog', !open.supportDialog)}
      />
    </Root>
  );
}
